/** External */
import React from "react";
import { CrownPremiumFilled } from "@toddle-edu/ds-icons";

/** Internal */
import classes from "./CrownPremiumFilledWrapper.scss";
import { useI18n } from "Hooks";

const CrownPremiumFilledWrapper = ({
  variant = "on",
  size = "xxx-small",
  customStyles = {},
}) => {
  const { t } = useI18n();
  return (
    <div
      style={customStyles}
      className={classes.container}
      role="img"
      aria-label={t("common:premium")}
    >
      <CrownPremiumFilled variant={variant} size={size} />
    </div>
  );
};

export default CrownPremiumFilledWrapper;
